import { ComponentProps } from "react";
import styles from "./PhoneNumberInput.module.css";
import Label from "../Label";
import { UseFormRegisterReturn } from "react-hook-form";

type PhoneNumberInputProps = ComponentProps<"input"> & {
  label: string;
  register?: UseFormRegisterReturn;
  error?: string;
  required?: boolean;
  content?: string;
  hasTooltip?: boolean;
  countryCodeRegister?: UseFormRegisterReturn;
  countryCodes?: string[];
  disabled?: boolean;
  underDevelopment?: boolean;
};

export default function PhoneNumberInput({
  label,
  register,
  hasTooltip,
  content,
  required,
  countryCodeRegister,
  countryCodes,
  error,
  disabled,
  underDevelopment,
  ...props
}: PhoneNumberInputProps) {
  return (
    <div className={styles["form__input--container"]}>
      <Label
        required={required}
        tooltipContent={content}
        underDevelopment={underDevelopment}
      >
        {label}
      </Label>
      <div
        className={`${styles["phone__input--container"]} ${
          disabled ? styles["phone__input--disabled"] : ""
        }`}
      >
        <select
          className={styles["phone__dropdown"]}
          {...countryCodeRegister}
          disabled={disabled}
          tabIndex={-1}
        >
          {countryCodes?.map((code: string) => (
            <option key={code} value={code}>
              {code}
            </option>
          ))}
        </select>
        <hr />
        <input
          style={{ border: "none" }}
          id="phone"
          placeholder={disabled ? "" : "(XXX) XXX-XXXX"}
          className={styles["form__input"]}
          {...register}
          disabled={disabled}
        />
      </div>
      {error && (
        <span role="alert" className={styles["form__input--error"]}>
          {error}
        </span>
      )}
    </div>
  );
}
